import { BrowserHttpClient } from '@/services/Http/BrowserHttpClient';
import { AbstractStatesScheduler } from '@/services/UserActivity/AbstractStatesScheduler';
import { logger } from '@/utils/logger/logger';

class SeriesSubscriptionStatesScheduler extends AbstractStatesScheduler<boolean> {
    private static instance: SeriesSubscriptionStatesScheduler;
    public static CHANGE_EVENT = 'subscriptionState:change';
    private allSubscribedSeries: Set<string> = undefined;

    private constructor() {
        super();
    }

    public static getInstance(): SeriesSubscriptionStatesScheduler {
        if (!SeriesSubscriptionStatesScheduler.instance) {
            SeriesSubscriptionStatesScheduler.instance = new SeriesSubscriptionStatesScheduler();
        }
        return SeriesSubscriptionStatesScheduler.instance;
    }

    protected getApiEndpoint(): string {
        throw new Error('Series API is different as definite all subscribed series is queried at once');
    }

    protected getChangedEventName(): string {
        return SeriesSubscriptionStatesScheduler.CHANGE_EVENT;
    }

    public getState(itemKey: string): boolean | undefined {
        // Known from initialState
        if (this.states.has(itemKey)) {
            return this.states.get(itemKey);
        }
        if (this.allSubscribedSeries === undefined) {
            return undefined;
        }
        return this.allSubscribedSeries.has(itemKey);
    }

    protected async fetchStates(keys: string[]): Promise<string[]> {
        if (this.allSubscribedSeries === undefined) {
            try {
                const response: string[] = await new BrowserHttpClient().get({ path: '/series/subscriptions' });

                // Update the states map and notify subscribers
                if (response) {
                    this.allSubscribedSeries = new Set(response);
                }
            } catch (error) {
                logger.error('Failed to fetch Series subscription states', error);
                return keys;
            }
        }

        keys.forEach((key) => {
            const state = this.getState(key);
            this.notifySubscribers(key, state);
        });
        return [];
    }
}

export default SeriesSubscriptionStatesScheduler;
